/* @ngInject */
function SocialMediaInstagramPreviewController ($scope, $sce, $translate, Utils) {
  const limitCaptionLength = 50

  $scope.flags = {
    showMore: false
  }

  $scope.captionText = ''
  $scope.currentImageIndex = 0
  $scope.currentImageUrl = ''

  const api = {
    _getHtmlText,
    _getCurrentImage,
    _getImagesCount,
    _isCarouselMode,
    _onCarouselDotClick,
    _onCarouselSwipe
  }

  this.getApi = () => api

  activate()
  function activate () {
    $scope.captionText = api._getHtmlText(Utils.truncateText($scope.caption, limitCaptionLength))

    if ($scope.materials && $scope.materials.length > 0) {
      $scope.currentImageIndex = ($scope.selectedIndex !== null &&
        $scope.selectedIndex < $scope.materials.length) ? $scope.selectedIndex : 0
    } else {
      $scope.currentImageIndex = 0
    }

    $scope.currentImageUrl = api._getCurrentImage()
  }

  $scope.onShowMore = () => {
    $scope.flags.showMore = !$scope.flags.showMore

    const captionMaxText = api._getHtmlText($scope.caption)
    const captionMinText = api._getHtmlText(Utils.truncateText($scope.caption, limitCaptionLength))

    if ($scope.flags.showMore) {
      $scope.captionText = captionMaxText
      return
    }

    $scope.captionText = captionMinText
  }

  $scope.getShowMoreText = () => {
    const showLessText = $translate.instant('showLess')
    const showMoreText = $translate.instant('showMore')

    if ($scope.flags.showMore) {
      return showLessText
    }

    return showMoreText
  }

  $scope.showCaptionMore = (caption) => {
    const isThanMinCaptionLength = caption.length > limitCaptionLength
    return isThanMinCaptionLength
  }

  $scope.getCurrentImage = () => api._getCurrentImage()
  $scope.getImagesCount = () => api._getImagesCount()
  $scope.isCarouselMode = () => api._isCarouselMode()
  $scope.onCarouselDotClick = (index) => api._onCarouselDotClick(index)
  $scope.onCarouselSwipe = (direction) => api._onCarouselSwipe(direction)

  function _getCurrentImage () {
    if ($scope.materials && $scope.materials.length > 0 && $scope.currentImageIndex < $scope.materials.length) {
      const currentMaterial = $scope.materials[$scope.currentImageIndex]
      return currentMaterial.url || currentMaterial.thumbnail
    }
    return $scope.imageUrl
  }

  function _getImagesCount () {
    return $scope.materials ? $scope.materials.length : 1
  }

  function _isCarouselMode () {
    return $scope.materials && $scope.materials.length > 1
  }

  function _onCarouselDotClick (index) {
    if ($scope.materials && index >= 0 && index < $scope.materials.length) {
      $scope.currentImageIndex = index
      $scope.currentImageUrl = api._getCurrentImage()
    }
  }

  function _onCarouselSwipe (direction) {
    if (!api._isCarouselMode()) return

    if (direction === 'left' && $scope.currentImageIndex < $scope.materials.length - 1) {
      $scope.currentImageIndex++
      $scope.currentImageUrl = api._getCurrentImage()
    } else if (direction === 'right' && $scope.currentImageIndex > 0) {
      $scope.currentImageIndex--
      $scope.currentImageUrl = api._getCurrentImage()
    }
  }

  function _getHtmlText (text) {
    const newTextHtml = text.replaceAll('\n', '<br>')
    return $sce.trustAsHtml(newTextHtml)
  }
}

export { SocialMediaInstagramPreviewController }
